export class NovedadI {
    id : BigInteger;
    idFte : any;
    idUsuario : any;
    idPerido : any;
    tipoNov : String;
    fechaNov : String;
    justNov : String;
}
